import { render, staticRenderFns } from "./Supervisors.vue?vue&type=template&id=3fb62422&"
import script from "./Supervisors.vue?vue&type=script&lang=js&"
export * from "./Supervisors.vue?vue&type=script&lang=js&"
import style0 from "./Supervisors.vue?vue&type=style&index=0&id=3fb62422&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports